import apiClient from "./apiClient"
import { ApiTag } from "./util/ApiTag"
import { McoEndpointBuilder } from "./apiSlice"

const medicalHierarchyEndpoints = (build: McoEndpointBuilder) => ({
	medicalHierarchyGetSpecialitiesByConsultant: build.query({
		queryFn: apiClient.medicalHierarchy.getSpecialitiesByConsultant,
		providesTags: [
			ApiTag.Tenant,
			{ type: ApiTag.MedicalHierarchy, id: "specialities" }
		]
	}),
	medicalHierarchyGetSpecialitiesByCondition: build.query({
		queryFn: apiClient.medicalHierarchy.getSpecialitiesByCondition,
		providesTags: [
			ApiTag.Tenant,
			{ type: ApiTag.MedicalHierarchy, id: "specialities" }
		]
	}),
	medicalHierarchyGetProblemAreas: build.query({
		queryFn: apiClient.medicalHierarchy.getProblemAreas,
		providesTags: [
			ApiTag.Tenant,
			{ type: ApiTag.MedicalHierarchy, id: "problemareas" }
		]
	})
})

export default medicalHierarchyEndpoints
